import { useQuery } from 'react-query'
import axios from 'axios'

const fetchTemplate = id => axios.get(`/admin/v1/templates/${id}.json`).then(res => res.data)

const useTemplate = id => {
  return useQuery(['template', id], () => fetchTemplate(id), { refetchOnWindowFocus: false })
}
export default useTemplate
